/*
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
 */
import logo from './logo.svg';
import './App.css';

function App() {
  const handleClick = () => {
    fetch('https://bold-lake-353c.hys18011401591.workers.dev/')
      .then(response => response.text())
      .then(data => alert('worker接口调用成功，' + data));
  }
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <div>
          <button onClick={handleClick}>点我调用cloudflare worker接口</button>
        </div>
      </header>
    </div>
  );
}

export default App;
